import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { resource } from '@/utils/tools/index';
export default {
  name: 'SelectDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    pdfurl: {
      type: String,
      default: ''
    },
    zipFileName: {
      type: String,
      default: '下载'
    }
  },
  data: function data() {
    return {
      dialogVisible: true,
      downloadImgSrc: resource('download_dialog2.png')
    };
  },
  computed: {
    download_pdfurl: function download_pdfurl() {
      var attachment = '';
      attachment = encodeURIComponent("attachment;filename=".concat(encodeURI(this.zipFileName)));
      var u = "".concat(this.pdfurl, "&download_name=").concat(this.zipFileName, "&response-content-disposition=").concat(attachment);
      return u;
    }
  },
  methods: {
    download: function download() {
      window.location.href = this.download_pdfurl;
      this.$emit('update:showDialog', false);
    },
    handleClose: function handleClose() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('update:showDialog', false);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};